import React from 'react';

import Icon from '../../../assets/images/error.svg';

export const IconRemove = (): JSX.Element => {
  return <img src={Icon} alt="Icone" width="10px" />;
};
